
import { NavBar } from 'components/NavBar/NavBar'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { Pagination } from 'components/Pagination/Pagination'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Flex, MainHeadline, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { getParams, handlePagination } from 'utils/helpers'
import { clearInventoryDashboard, getInventoryItemsDashboard } from 'features/inventory/inventoryItemsSlice'
import { FilterEnum, LinkEnum } from 'components/Filter/SingleFilter'
import { ColorVariant, MediumText } from 'styling/TypographyV2'

export const InventoryDashboard = () => {
    const { dashboard } = useSelector((store: RootState) => store.inventoryItems)
    const [params, setParams] = useState<any>(getParams({ location }))

    useQueryPagination({ fetchFunctions: [getInventoryItemsDashboard], cleanUpFunctions: [clearInventoryDashboard], params })

    const columns: IHonestTableColumn<any>[] = [
        { id: 'name', header: 'NAME', cell: (item) => item.name ?? '-' },
        { id: 'sku', header: 'SKU', cell: (item) => item.sku ?? '-' },
        { id: 'quantity', header: 'QUANTITY', cell: (item) => item.quantity ?? '-' },
        { id: 'minLevel', header: 'MIN LEVEL', cell: (item) => item.minLevel ?? '-' },
        { id: 'isLowStock', header: 'IS LOW STOCK', cell: (item) => (item.isLowStock ? 'Yes' : 'No') },
    ]

    const filters = [
        {
            type: FilterEnum.ASYNC_SELECT,
            name: 'Location',
            link: LinkEnum.LOCATIONS,
            propName: 'locationId',
            single: true
        },
        {
            type: FilterEnum.ASYNC_SELECT,
            link: LinkEnum.INVENTORY_CATEGORIES,
            name: 'Category',
            state: null,
            single: true,
            propName: 'categoryId'
        }
    ]

    return <>
        <NavBar input placeholder='Search items...' setParams={setParams} filterOptions={filters} enableTemporaryManualClosing />
        <PageWrapper>
            <Flex between center mb='16' >
                <MainHeadline>Inventory Dashboard</MainHeadline>
                <MediumText colorVariant={ColorVariant.SECONDARY}>
                    Low Stock: {dashboard?.lowStockCount || 0}
                </MediumText>
            </Flex>
            {!dashboard?.data?.length ? (
                <NoItems title='Items' />
            ) : (
                <HonestTable columns={columns} data={dashboard.data} keyField='id' />
            )}
        </PageWrapper>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(dashboard?.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}